// extracted by mini-css-extract-plugin
module.exports = {"downloadPdfLink":"DownloadPdfLink_downloadPdfLink__SiVj5","ready":"DownloadPdfLink_ready__8AmuQ","loading":"DownloadPdfLink_loading__2NJ6i"};